import React from 'react';
import Icon from '../../../components/AppIcon';

const OnboardingFunnel = ({ data, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-sm animate-pulse">
        <div className="h-6 bg-muted rounded w-1/3 mb-6"></div>
        <div className="space-y-4">
          {[1, 2, 3, 4]?.map((i) => (
            <div key={i} className="h-20 bg-muted rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  const calculateConversionRate = (current, previous) => {
    if (!previous || previous === 0) return 0;
    return ((current / previous) * 100)?.toFixed(1);
  };

  const calculateDropOff = (current, previous) => {
    if (!previous || previous === 0) return 0;
    return (((previous - current) / previous) * 100)?.toFixed(1);
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 lg:p-8 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Merchant Onboarding Funnel</h3>
        <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Last 30 Days</span>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {data?.map((stage, index) => {
          const previousStage = index > 0 ? data?.[index - 1] : null;
          const conversionRate = previousStage ? calculateConversionRate(stage?.count, previousStage?.count) : 100;
          const dropOffRate = previousStage ? calculateDropOff(stage?.count, previousStage?.count) : 0;
          const widthPercentage = (stage?.count / data?.[0]?.count) * 100;

          return (
            <div key={stage?.stage} className="relative">
              <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-4 mb-2">
                <div className="flex items-center gap-3 min-w-0 md:min-w-[200px]">
                  <div className={`${stage?.color} p-2 rounded-lg flex-shrink-0`}>
                    <Icon name={stage?.icon} size={18} className="text-white" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm md:text-base font-medium text-foreground truncate">{stage?.stage}</p>
                    <p className="text-xs text-muted-foreground">{stage?.description}</p>
                  </div>
                </div>

                <div className="flex items-center gap-4 md:gap-6 flex-wrap md:flex-nowrap md:ml-auto">
                  <div className="flex items-center gap-2">
                    <span className="text-xl md:text-2xl font-semibold text-foreground data-text">{stage?.count?.toLocaleString('id-ID')}</span>
                    <span className="text-xs text-muted-foreground">merchants</span>
                  </div>
                  
                  {index > 0 && (
                    <>
                      <div className="flex items-center gap-1 text-success">
                        <Icon name="TrendingUp" size={14} />
                        <span className="text-xs md:text-sm font-medium">{conversionRate}%</span>
                      </div>
                      {dropOffRate > 0 && (
                        <div className="flex items-center gap-1 text-error">
                          <Icon name="TrendingDown" size={14} />
                          <span className="text-xs md:text-sm font-medium">{dropOffRate}% drop-off</span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="relative h-3 md:h-4 bg-muted rounded-full overflow-hidden">
                <div 
                  className={`absolute inset-y-0 left-0 ${stage?.color} rounded-full transition-all duration-500`}
                  style={{ width: `${widthPercentage}%` }}
                />
              </div>
              {index < data?.length - 1 && (
                <div className="flex justify-center my-2">
                  <Icon name="ChevronDown" size={20} className="text-muted-foreground" />
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Overall Conversion</p>
            <p className="text-lg md:text-xl font-semibold text-foreground data-text">
              {calculateConversionRate(data?.[data?.length - 1]?.count, data?.[0]?.count)}%
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Avg. Time to Activate</p>
            <p className="text-lg md:text-xl font-semibold text-foreground data-text">4.2 days</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Verification Rate</p>
            <p className="text-lg md:text-xl font-semibold text-foreground data-text">
              {calculateConversionRate(data?.[2]?.count, data?.[1]?.count)}%
            </p>
          </div>
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-1">Activation Rate</p>
            <p className="text-lg md:text-xl font-semibold text-foreground data-text">
              {calculateConversionRate(data?.[3]?.count, data?.[2]?.count)}%
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingFunnel;